import React, { Component } from "react";
import AppActions from "../flux/AppActions";
import Toast from "../toast";
import AjaxLoader from "../components/AjaxLoader";
import CocktailsList from "../components/CocktailsList";

const locale = ( typeof ( window.AppWizardLocale ) !== 'undefined' ? window.AppWizardLocale : false );
if ( !locale ) {
    throw new Error( 'Error: Locale not loaded' );
}

const $ = window.jQuery;
const toast = new Toast();

class PageCocktailsBeefeaterIsHot extends Component {
    constructor(props) {
        super( props );

        this.inputRef = React.createRef();

        this.state = props.app.state;

        this.__getCocktails = this.__getCocktails.bind( this );
        this.__onCocktailClick = this.__onCocktailClick.bind( this );
    }

    componentDidMount() {
        this.__getCocktails( this.props );
    }

    __goToHomePage(e) {
        e.preventDefault();
        window.history.back();
    }

    __getCocktails(props) {
        window.scrollTo( {
            top: 0
        } );

        this.setState( {
            loading: true
        } );

        let locale = props.locale;
        let { ajaxurl, nonce_name, nonce_value } = locale;
        let self = this;
        let ajaxConfig = {
            url: ajaxurl,
            method: "POST",
            timeout: 29000,
            cache: false,
            async: true,
            data: {
                action: "bth_ajax",
                request: "get_cocktails",
                brands: props.app.state.brands.map(brand => brand.id),
                event: props.app.state.event ? props.app.state.event.id : null,
                [nonce_name]: nonce_value
            }
        };

        $.ajax( ajaxConfig )
            .done( function (r) {
                if ( r ) {
                    if ( r.success ) {
                        if ( r.data ) {
                            AppActions.updatePage( 'cocktailsBeefeaterIsHot' );
                            self.setState( {
                                page_data: r.data.items,
                                ingredients: r.data.ingredients,
                                numar_portii: r.data.numar_portii,
                                loading: false
                            } );
                        }
                        else {
                            toast.show( locale.texts.empty_response, Toast.TYPE_ERROR );
                        }
                    }
                    else {
                        if ( r.data ) {
                            toast.show( r.data, Toast.TYPE_ERROR );
                        }
                        else {
                            toast.show( locale.texts.empty_response, Toast.TYPE_ERROR );
                        }
                    }
                }
                else {
                    toast.show( locale.texts.no_response, Toast.TYPE_ERROR );
                }
            } )
            .fail( function (x, s, e) {
                toast.show( e, Toast.TYPE_ERROR );
            } )
            .always( function () {
                // self.setState( {
                //     loading: false
                // } );
            } );
    }

    __onCocktailClick(cocktailId) {
        let cocktail = this.state.page_data.find(cocktail => cocktail.id === cocktailId);
        AppActions.updateStore( {
            cocktail: cocktail,
            page: 'shoppingListBeefeaterIsHot',
        } );
    }

    render() {
        let page_data = ( this.state.page_data.length ? this.state.page_data : false );
        let ingredients = ( this.state.ingredients ? this.state.ingredients : false );
        let numar_portii = ( this.state.numar_portii ? this.state.numar_portii : false );

        return (
            <React.Fragment>
                <header className="header header--cocktails-page d-flex flex-wrap justify-content-center align-items-start align-items-md-center">
                    <div className="header__background-image d-none d-md-block"
                         style={{backgroundImage: `url('${locale.img_uri}/afisare-cocktails/beefeater-is-hot-cocktails-desktop.jpg')`}}>
                    </div>
                    <div className="header__background-image d-block d-md-none"
                         style={{backgroundImage: `url('${locale.img_uri}/afisare-cocktails/beefeater-is-hot-cocktails-mobile.jpg')`}}>
                    </div>
                    <div className="header__text text-left">
                        <h2 className="header__text-title-small text-center text-md-left">
                            ÎNCEARCĂ CELE MAI INEDITE
                        </h2>
                        <h1 className="header__text-title text-center text-md-left">
                            REȚETE DE<br/>
                            HOT DRINKS
                        </h1>
                    </div>
                </header>

                {page_data !== false && page_data.length &&
                <CocktailsList
                    items={page_data}
                    ingredients={ingredients}
                    numar_portii={numar_portii}
                    onItemClick={this.__onCocktailClick}
                />}

                <h3 className="container text-center mt-5">
                    LASĂ-TE INSPIRAT ȘI AMPLIFICĂ SAVOAREA ORICĂREI OCAZII! DESCOPERĂ AROME NOI, ÎNCEARCĂ COMBINAȚII NEAȘTEPTATE,
                    DĂ CHEERS CU PRIETENII SAU CU PROPRIA REUȘITĂ! ALEGE MOMENTUL CARE TE INSPIRĂ ȘI DESCOPERĂ
                    ȘI ALTE PROPUNERI DE DRINK-URI CU BEEFEATER!
                </h3>

                <div className="text-center">
                    <a href="https://bethehost.ro/savoarea-momentelor-impreuna/#moments"
                       className="button button--xl">
                        INSPIRĂ-TE!
                    </a>
                </div>

                <div className="cocktails__pagination text-center mt-5 mb-5">
                    <p className="cocktails__pagination-text">
                        Mergi înapoi
                    </p>
                    <a onClick={this.__goToHomePage.bind(this)} href="#" className="cocktails__pagination-link">
                        <img src={locale.img_uri + 'afisare-cocktails/back-button.svg'} alt=""/>
                    </a>
                </div>
            </React.Fragment>
        );
    }
}

export default PageCocktailsBeefeaterIsHot;
